<template>
    <div>
        <hs-breadcrumb :breadcrumb="breadcrumb"></hs-breadcrumb>
        <Card :bordered="false" :style="{marginBottom:'10px'}">
            <div class="hs-screen-row">
                <Select v-model="params.jumpType" placeholder="跳转类型" clearable style="width:200px">
                    <Option value="">全部</Option>
                    <Option value="1">URL</Option>
                    <Option value="2">APP内页</Option>
                </Select>
            </div>
            <div class="hs-screen-row">
                <Select v-model="params.isDisable" placeholder="状态" clearable style="width:200px">
                    <Option value="">全部</Option>
                    <Option value="0">已启用</Option>
                    <Option value="1">已禁用</Option>
                </Select>
            </div>
            <div class="hs-screen-row">
                <DatePicker @on-change="changeDate" v-model="dateInit" type="daterange" :editable="false"
                            separator=" ~ " split-panels transfer
                            placeholder="创建时间" style="width: 200px"></DatePicker>
            </div>
            <div class="hs-screen-row">
                <Button type="primary" @click="findBannerList">查询</Button>
            </div>
            <div class="hs-screen-row">
                <Button @click="resetScreen">重置</Button>
            </div>
        </Card>

        <Card :bordered="false" :style="{marginBottom:'10px'}">
            <!--标题-->
            <div slot="title">
                <div class="hs-screen-box">
                    <div>banner列表</div>
                    <div>
                        <ButtonGroup>
                            <Button @click="findBannerList">
                                <Icon type="md-refresh" size="15"/>
                            </Button>
                            <Button @click="showBannerOpe(2)">新增banner</Button>
                        </ButtonGroup>
                    </div>
                </div>
            </div>
            <!--表格数据-->
            <Table :columns="columns" :data="data" size="small" :stripe="true" :loading="isTableLoading">

                <template slot-scope="{ row, index }" slot="isDisable">
                    <Tag color="green" v-if="row.isDisable === 0" size="default">启用</Tag>
                    <Tag color="volcano" v-if="row.isDisable === 1" size="default">禁用</Tag>
                </template>

                <template slot-scope="{row, index}" slot="bannerUrl">
                    <div class="j-banner-image">
                        <img :src="row.bannerUrl">
                    </div>
                </template>

                <template slot-scope="{row, index}" slot="jumpType">
                    <span v-if="!row.jumpType">-</span>
                    <span v-if="row.jumpType == 1">URL</span>
                    <span v-if="row.jumpType == 2">APP内页</span>
                </template>

                <template slot-scope="{row, index}" slot="jumpUrl">
                    <span v-if="row.jumpUrl">{{row.jumpUrl}}</span>
                    <span v-else>-</span>
                </template>

              <template slot-scope="{row, index}" slot="bannerPosition">
                <span v-if="row.bannerPosition == 1">banner</span>
                <span v-if="row.bannerPosition == 2">弹窗</span>
              </template>

                <template slot-scope="{ row }" slot="action">
                    <Button type="success" size="small" style="margin-right: 5px" @click="showBannerOpe(1, row)">查看
                    </Button>
                    <Button type="primary" size="small" style="margin-right: 5px" @click="showBannerOpe(3, row)">编辑
                    </Button>

                    <Dropdown transfer trigger="click">
                        <Button size="small">
                            <Icon type="ios-more" size="22"/>
                        </Button>
                        <DropdownMenu slot="list">
                            <DropdownItem v-if="row.isDisable === 0" @click.native="isDisableUser(row)">禁用
                            </DropdownItem>
                            <DropdownItem v-if="row.isDisable === 1" @click.native="isDisableUser(row)">启用
                            </DropdownItem>
                            <DropdownItem @click.native="isDelUser(row)">删除</DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </template>
            </Table>
            <!--分页-->
            <div class="hs-page">
                <Page :total="total" show-sizer show-total transfer @on-change="changePage"
                      @on-page-size-change="changePageSize"/>
            </div>
        </Card>

        <!--显示模态框-->
        <banner-ope ref="bannerOpe" @changeDate="findBannerList"></banner-ope>
    </div>
</template>

<script>
    import hsBreadcrumb from '@/components/hs-breadcrumb';
    import bannerOpe from './components/banner-ope';

    export default {
        name: "banner",
        data() {
            return {
                admin: JSON.parse(sessionStorage.getItem('J-ADMIN')),
                total: 0,
                dateInit: '',
                isTableLoading: false,
                // 参数
                params: {
                    page: 1,
                    rows: 10,
                    jumpType: '',
                    isDisable: '',
                    startTime:'',
                    endTime: '',
                },
                // 表格列
                columns: [
                    {
                        type: 'index',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: 'ID',
                        minWidth: 120,
                        key: 'bannerId'
                    },
                    {
                        title: 'banner',
                        minWidth: 120,
                        slot: 'bannerUrl'
                    },
                    {
                        title: '跳转类型',
                        minWidth: 120,
                        slot: 'jumpType'
                    },
                    {
                        title: '跳转值',
                        minWidth: 120,
                        slot: 'jumpUrl'
                    },
                    {
                      title: '展示位置',
                      minWidth: 120,
                      slot: 'bannerPosition'
                    },
                    {
                        title: '排序',
                        minWidth: 120,
                        key: 'bannerIndex'
                    },
                    {
                        title: '状态',
                        slot: 'isDisable',
                        align: 'center',
                        width: 120
                    },
                    {
                        title: '创建时间',
                        key: 'createTime',
                        width: 150
                    },
                    {
                        title: '操作',
                        slot: 'action',
                        width: 180,
                        align: 'center'
                    }
                ],
                // 表格数据
                data: [],
                // 面包屑
                breadcrumb: [
                    {name: '首页', url: '', icon: 'ios-home-outline', size: 18},
                    {name: 'Banner管理', url: '', icon: '', size: 0},
                    {name: 'banner列表', url: '', icon: '', size: 0}
                ],
              tenantList: []
            }
        },
        created() {
          // 租户-列表查询
            // banner-列表查询
            this.findBannerList();
        },
        methods: {
            // banner-列表查询
            findBannerList() {
                this.isTableLoading = true;
                this.axios.post('/banner/findBannerList', this.params).then(res => {
                    console.log(res);
                    this.isTableLoading = false;
                    if (res.status == 200) {
                        this.total = res.data.total;
                        this.data = res.data.rows;
                    }
                    if (res.status == 500) {
                        this.$Notice.error({
                            title: '服务器内部错误',
                            desc: '查询banner列表接口报错',
                            duration: 0
                        });
                    }
                })
            },
            // 是否删除banner
            isDelUser(row) {
                // console.log(row)
                this.$Modal.confirm({
                    title: `是否删除当前Banner？`,
                    onOk: () => {
                        // this.$Message.info('您点击了确定.');
                        this.deleteBanner(row);
                    },
                    onCancel: () => {
                        this.$Message.info('您点击了取消.');
                    }
                });
            },
            // 是否禁用banner
            isDisableUser(row) {
                // console.log(row)
                this.$Modal.confirm({
                    title: `是否${row.isDisable ? '开启' : '禁用'}当前Banner？`,
                    onOk: () => {
                        this.isDisable(row);
                    },
                    onCancel: () => {
                        this.$Message.info('您点击了取消.');
                    }
                });
            },
            // 删除banner
            deleteBanner(row) {
                this.$Spin.show();
                this.axios.post('/banner/deleteBanner', {
                    bannerId: row.bannerId
                }).then(res => {
                    console.log(res);
                    setTimeout(() => {
                        this.$Spin.hide();
                    }, 300);
                    if (res.status == 200) {
                        this.$Message.success('操作成功.');
                        this.findBannerList();
                    }
                    if (res.status == 201) {
                        // this.$Message.error(res.msg);
                        this.$Notice.error({
                            title: '删除banner失败',
                            desc: res.msg
                        });
                    }
                    if (res.status == 500) {
                        this.$Notice.error({
                            title: '服务器内部错误',
                            desc: '删除banner接口报错',
                            duration: 0
                        });
                    }
                })
            },
            // 禁用或开启banner
            isDisable(row) {
                this.$Spin.show();
                this.axios.post('/banner/isDisable', {
                    bannerId: row.bannerId,
                    isDisable: row.isDisable ? 0 : 1
                }).then(res => {
                    console.log(res);
                    setTimeout(() => {
                        this.$Spin.hide();
                    }, 300);
                    if (res.status == 200) {
                        this.$Message.success('操作成功.');
                        this.findBannerList();
                    }
                    if (res.status == 500) {
                        this.$Notice.error({
                            title: '服务器内部错误',
                            desc: '禁用banner接口报错',
                            duration: 0
                        });
                    }
                })
            },
            // 显示操作模态框
            showBannerOpe(type, row) {
                /**
                 * type判断
                 * 1.查看 2.新增 3.编辑
                 */
                this.$refs.bannerOpe.show(type, row);
            },
            // 日期条件赋值
            changeDate(e) {
                this.params.startTime = e[0];
                this.params.endTime = e[1];
            },
            // 重置筛选条件
            resetScreen() {
                this.params.jumpType = '';
                this.params.isDisable = '';
                this.params.startTime = '';
                this.params.endTime = '';
                this.dateInit = '';
            },
            // 改变页数
            changePage(e) {
                this.params.page = e;
                this.findBannerList();
            },
            // 改变页容量
            changePageSize(e) {
                this.params.rows = e;
                this.findBannerList();
            },
        },
        components: {
            hsBreadcrumb,
            bannerOpe
        }
    }
</script>

<style scoped>
    .j-banner-image{
        width: 100px;
        height: 50px;
        padding: 5px;
    }
    .j-banner-image img{
        width: auto;
        height: 100%;
    }
    /deep/ .table-info-row td {
      background-color: #fff3a8;
      color: #000000;
    }
</style>